import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-dad06003.js";
const n = {}, r = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, s = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  d: "M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"
}, null, -1), _ = [
  s
];
function h(a, l) {
  return e(), t("svg", r, _);
}
const d = /* @__PURE__ */ c(n, [["render", h]]);
export {
  d as default
};
